var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33326 25.5C6.63326 25.5 8.49988 23.6334 8.49988 21.3334V17.1666H4.33326C2.03326 17.1666 0.166626 19.0334 0.166626 21.3334C0.166626 23.6334 2.03326 25.5 4.33326 25.5Z",
    fill: "#6A7081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166626 13C0.166626 10.7 2.03326 8.83337 4.33326 8.83337H8.49988V17.1666H4.33326C2.03326 17.1666 0.166626 15.3 0.166626 13Z",
    fill: "#848A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166626 4.66668C0.166626 2.36667 2.03326 0.5 4.33326 0.5H8.49988V8.83338H4.33326C2.03326 8.83338 0.166626 6.96675 0.166626 4.66668Z",
    fill: "#A0A5B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.5H12.6667C14.9663 0.5 16.8338 2.36667 16.8338 4.66668C16.8338 6.96675 14.9663 8.83338 12.6667 8.83338H8.5V0.5Z",
    fill: "#6A7081"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8338 13C16.8338 15.3 14.9663 17.1666 12.6667 17.1666C10.3666 17.1666 8.5 15.3 8.5 13C8.5 10.7 10.3666 8.83337 12.6667 8.83337C14.9663 8.83337 16.8338 10.7 16.8338 13Z",
    fill: "#4B556C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFigma);
export default __webpack_public_path__ + "static/media/logo-figma.1020f71d843faa90bd3befec990ef824.svg";
export { ForwardRef as ReactComponent };